import { AvisosProvider } from './lib/avisos';
import { moduloDe, useArribaAlNavegar, useRuta } from './lib/ruta';
import { useTema } from './lib/tema';
import { BarraInferior, CabeceraMovil, MenuLateral } from './componentes/navegacion/Navegacion';
import { Inicio } from './pantallas/Inicio';
import { Bandeja } from './pantallas/Bandeja';
import { Suenos } from './pantallas/suenos/Suenos';
import { SuenoDetalle } from './pantallas/suenos/SuenoDetalle';
import { SuenoNuevo } from './pantallas/suenos/SuenoNuevo';
import { Diario } from './pantallas/Diario';
import { Notas } from './pantallas/Notas';
import { Biblioteca } from './pantallas/biblioteca/Biblioteca';
import { ElementoBibliotecaDetalle } from './pantallas/biblioteca/ElementoBibliotecaDetalle';
import { Cursos } from './pantallas/cursos/Cursos';
import { ActividadDetalle } from './pantallas/cursos/ActividadDetalle';
import { Astrologia } from './pantallas/Astrologia';
import { Reflexiones } from './pantallas/Reflexiones';
import { EspacioLibre } from './pantallas/EspacioLibre';
import { Mas } from './pantallas/Mas';
import { NoEncontrado } from './pantallas/NoEncontrado';

function Pantalla({ partes }: { partes: string[] }) {
  const [modulo, id] = partes;
  switch (modulo ?? 'inicio') {
    case 'inicio': return <Inicio />;
    case 'bandeja': return <Bandeja />;
    case 'suenos':
      if (id === 'nuevo') return <SuenoNuevo />;
      return id ? <SuenoDetalle key={id} id={id} /> : <Suenos />;
    case 'diario': return <Diario />;
    case 'notas': return <Notas />;
    case 'biblioteca': return id ? <ElementoBibliotecaDetalle key={id} id={id} /> : <Biblioteca />;
    case 'cursos': return id ? <ActividadDetalle key={id} id={id} /> : <Cursos />;
    case 'astrologia': return <Astrologia />;
    case 'reflexiones': return <Reflexiones />;
    case 'libre': return <EspacioLibre />;
    case 'mas': return <Mas />;
    default: return <NoEncontrado />;
  }
}

export function App() {
  const { ruta, partes } = useRuta();
  const [oscuro, alternarTema] = useTema();
  useArribaAlNavegar(ruta);
  const modulo = moduloDe(partes);

  return (
    <div className={oscuro ? 'app dark' : 'app'}>
      <AvisosProvider>
        <p className="ribbon" style={{ margin: 0 }}>Versión de desarrollo con datos ficticios · nada se guarda ni se conecta a servicios</p>
        <div className="shell">
          <MenuLateral modulo={modulo} oscuro={oscuro} alternarTema={alternarTema} />
          <main className="main">
            <div className="wrap">
              <CabeceraMovil oscuro={oscuro} alternarTema={alternarTema} />
              <Pantalla partes={partes} />
            </div>
          </main>
        </div>
        <BarraInferior modulo={modulo} />
      </AvisosProvider>
    </div>
  );
}
